/*
 * @format
 */
import React from 'react';
import PropTypes from 'prop-types';
import * as InventoryTag from '../../sharedComponents/inventoryTags/InventoryTag';
import Breadcrumbs from '../../sharedComponents/Breadcrumbs';
import { ContentContainerBodyShift } from '../../sharedComponents/LayoutHelpers';
import { FlexCol, FlexRow } from '../../sharedComponents/FlexGrid';
import Heading from '../../sharedComponents/Heading'
import HelmetWrapper from '../../sharedComponents/HelmetWrapper';
import HeroImageCombined from '../../sharedComponents/HeroImageCombined';
import RightRail from './RightRail';
import TabItems from './TabItems';
import ErrorNotification from './ErrorNotification';

export default class VenuePage extends React.Component {
    static propTypes = {
        map: PropTypes.node,
        errors: PropTypes.arrayOf(PropTypes.string),
        errorRef: PropTypes.shape({
            current: PropTypes.instanceOf(Element)
        }),
        title: PropTypes.string.isRequired,
        rightRail: PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.node
        }),
        assetId: PropTypes.string,
        inventoryType: PropTypes.oneOf(['Camping', 'DayUse', 'HuntingPermit', 'Lottery', 'POI', 'Pass', 'Permit', 'RecArea', 'Rental', 'Ticket', 'VehiclePermit']),
        activities: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
        breadcrumbPath: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                url: PropTypes.string
            })
        ),
        partOf: PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string
        }),
        starRating: PropTypes.node,
        cellRating: PropTypes.node,
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                content: PropTypes.node
            })
        )
    };

    static defaultProps = {
        activities: [],
        breadcrumbPath: []
    };

    renderActivities = () =>
        this.props.activities.map(({ name }) => (
            <li key={name} className="rec-park-pill">
                {name}
            </li>
        ));

    render() {
        const { title, rightRail, assetId, inventoryType, breadcrumbPath, partOf, starRating, cellRating, map, tabs, errors, errorRef } = this.props;
        const Tag = InventoryTag[`Inventory${inventoryType}`];

        return (
            <div className="rec-page">
                <div id="page-body">
                    <HelmetWrapper title={title} />
                    {assetId && <HeroImageCombined type="asset" id={assetId} />}
                    <ContentContainerBodyShift className="rec-venue-page">
                        <FlexRow>
                            {/* Left Rail */}
                            <FlexCol lg={8} className="rec-venue-page-left-rail">
                                {/* Breadcrumbs and the main title of this page */}
                                {!!breadcrumbPath.length && (
                                    <div className="rec-breadcrumb-wrap">
                                        <Breadcrumbs path={breadcrumbPath} />
                                    </div>
                                )}

                                <ErrorNotification
                                    errors={errors}
                                    errorHeader="You've encountered the following error(s):"
                                    innerRef={errorRef} />

                                {/* Main title of the page */}
                                <Heading headingLevel={1} appearance="h3" className="mb-1">
                                    {title}
                                </Heading>

                                {/* "Part of" statement and star rating */}
                                {partOf || starRating ? (
                                    <ul className="rec-subhead-wrap">
                                        {partOf ? (
                                            <li key={partOf.url}>
                                                Part of <a href={partOf.url}>{partOf.title}</a>
                                            </li>
                                        ) : null}

                                        {starRating ? (
                                            <li key={`rating-${starRating.rating}`} className="rec-subhead-rating">
                                                {starRating}
                                            </li>
                                        ) : null}
                                        {cellRating ? (
                                            <li className="rec-subhead-cell-rating">
                                                {cellRating}
                                            </li>
                                        ) : null}
                                    </ul>
                                ) : null}

                                {/* Pills and icons */}
                                <ul className="rec-inventory-tags rec-pill-wrap">
                                    {<Tag />}
                                    {this.renderActivities()}
                                </ul>

                                {/* Tabs */}
                                <div className="rec-venue-page-tabs-wrap">
                                    <TabItems tabs={tabs} />
                                </div>
                            </FlexCol>

                            {/* Right Rail */}
                            <FlexCol lg={4}>
                                <RightRail rightRail={rightRail} />
                            </FlexCol>
                        </FlexRow>
                    </ContentContainerBodyShift>

                    {/* Bottom Map */}
                    {map && <FlexRow hasGutters={false}>
                        <FlexCol className="rec-venue-page-map-wrapper">
                            <div id="map">{map}</div>
                        </FlexCol>
                    </FlexRow>}
                </div>
            </div>
        );
    }
}
